var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":"6LeNp-IpAAAAAP_LjuQ-7ydfz5jteIKHPg1Ck8Xn","loadRecaptchaScript":true},on:{"verify":_vm.onVerify,"expired":_vm.onCaptchaExpired}})}
var staticRenderFns = []

export { render, staticRenderFns }